import * as React from 'react';
import { cn } from '@/lib/utils';
import { buttonVariants } from '@/components/ui/button';
import { DotsHorizontalIcon } from '@radix-ui/react-icons';

const Pagination = ({ className, ...props }) => (
  <nav
    role='navigation'
    aria-label='pagination'
    className={cn('mx-auto flex w-full justify-center', className)}
    {...props}
  />
);
Pagination.displayName = 'Pagination';

const PaginationContent = React.forwardRef(({ className, ...props }, ref) => (
  <ul ref={ref} className={cn('flex flex-row items-center gap-1', className)} {...props} />
));
PaginationContent.displayName = 'PaginationContent';

const PaginationItem = React.forwardRef(({ className, isActive = false, disabled = false, ...props }, ref) => (
  <li
    ref={ref}
    className={cn(
      buttonVariants({
        variant: isActive ? 'secondary' : 'ghost',
        size: 'sm'
      }),
      'leading-none',
      'transition-none',
      {
        'hover:bg-black/10 cursor-pointer font-normal': !isActive && !disabled,
        'pointer-events-none bg-secondary/50': disabled,
        'pointer-events-none': isActive
      },
      className
    )}
    aria-current={isActive ? 'page' : undefined}
    {...props}
  />
));
PaginationItem.displayName = 'PaginationItem';

const PaginationEllipsis = ({ className, ...props }) => (
  <span
    aria-hidden
    className={buttonVariants({
      className,
      variant: 'ghost',
      size: 'sm'
    })}
    {...props}
  >
    <DotsHorizontalIcon className='h-4 w-4' />
    <span className='sr-only'>More pages</span>
  </span>
);
PaginationEllipsis.displayName = 'PaginationEllipsis';

export { Pagination, PaginationContent, PaginationItem, PaginationEllipsis };
